import { ca } from '@cian/analytics';

export function trackFaqLinkClick(linkText: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FeedBackForm',
    action: 'Click',
    label: `FAQ/${linkText}`,
  });
}
